import React from 'react';
import { SiteHeader } from './components/site/SiteHeader';
import { HeroSection } from './components/site/HeroSection';
import { MarqueeStrip } from './components/site/MarqueeStrip';
import { ServicesSection } from './components/site/ServicesSection';
import { WorkSection } from './components/site/WorkSection';
import { ProcessSection } from './components/site/ProcessSection';
import { FeatureBand } from './components/site/FeatureBand';
import { AboutSection } from './components/site/AboutSection';
import { TestimonialsSection } from './components/site/TestimonialsSection';
import { FaqSection } from './components/site/FaqSection';
import { ContactSection } from './components/site/ContactSection';
import { SiteFooter } from './components/site/SiteFooter';
export function App() {
  return <div className="min-h-screen w-full bg-bone-50 font-sans antialiased" data-id="element-0" data-mp="28tw6guwdqq51">
      <SiteHeader data-id="element-1" data-mp="28s2z1ddy01vz" />
      <main data-id="element-2" data-mp="23vkzqt1dsvr1">
        <HeroSection data-id="element-3" data-mp="23w4g45bdvc2y" />
        <MarqueeStrip data-id="element-4" data-mp="23ujl6el5pr4k" />
        <ServicesSection data-id="element-5" data-mp="23t8i6gzjcnei" />
        <WorkSection data-id="element-6" data-mp="3ik7gwiph6frp" />
        <ProcessSection data-id="element-7" data-mp="3ikqyfyb7r257" />
        <FeatureBand data-id="element-8" data-mp="3ijfx0558q6h9" />
        <AboutSection data-id="element-9" data-mp="3ihv0i9zd8dgr" />
        <TestimonialsSection data-id="element-10" data-mp="3mlawd43m29se" />
        <FaqSection data-id="element-11" data-mp="3mkhmhu9cv461" />
        <ContactSection data-id="element-12" data-mp="3mjzu58ptda3e" />
      </main>
      <SiteFooter data-id="element-13" data-mp="3rc9d24sih9w6" />
    </div>;
}